@file:UseSerializers(UuidSerializer::class)

package it.neckar.lizergy.model.configuration.quote.builder

import it.neckar.lizergy.lifeCycle.LizergyHasLifeCycle
import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.energy.BatteryCapacity
import it.neckar.uuid.HasValueClassUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.UuidSerializer
import it.neckar.uuid.ValueClassUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers
import kotlin.uuid.Uuid

/**
 * Describes a battery storage type - possibly including a inverter
 */
@Serializable
data class BatteryStorageType(
  /**
   * The UUID
   */
  override val id: BatteryStorageTypeId,

  /**
   * The description for the battery storage
   */
  val description: String,
  val shortDescription: String,
  val manufacturer: Manufacturer,
  /**
   * The amount of energy that can be stored
   */
  val storageCapacity: BatteryCapacity,
  val usableStorageCapacity: BatteryCapacity,

  val numberOfBatteryModules: Int,

  val compatibleWithIndependenceManager: Boolean = false,

  val dataSheetPath: String? = null,

  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,

  ) : HasValueClassUuid, LizergyHasLifeCycle {

  /**
   * An id for a battery storage type
   */
  @Serializable
  data class BatteryStorageTypeId(override val uuid: NativeUuid) : ValueClassUuid {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): BatteryStorageTypeId {
        return BatteryStorageTypeId(randomUuid4())
      }
    }
  }
}
